import {
  ADD_UPDATE_LOZIER_STORE_FAILURE,
  ADD_UPDATE_LOZIER_STORE_REQUEST,
  ADD_UPDATE_LOZIER_STORE_SUCCESS,
  FETCH_LOZIER_STORE_LIST_FAILURE,
  FETCH_LOZIER_STORE_LIST_REQUEST,
  FETCH_LOZIER_STORE_LIST_SUCCESS,
} from "./actionTypes";
import { LozierStoreListState } from "./types";

const initialState: LozierStoreListState = {
  lozierStoreList: [],
  loading: false,
  error: null,
  successMessage: "",
  totalCount: 0,
};

const lozierStoreReducer = (
  state = initialState,
  action: any
): LozierStoreListState => {
  switch (action.type) {
    case FETCH_LOZIER_STORE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_LOZIER_STORE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        lozierStoreList: action.payload.lozierStoreList,
        totalCount: action.payload.totalCount,
      };

    case FETCH_LOZIER_STORE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_UPDATE_LOZIER_STORE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ADD_UPDATE_LOZIER_STORE_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload.successMessage,
      };

    case ADD_UPDATE_LOZIER_STORE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default lozierStoreReducer;
